import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Loader from "../components/ui/Loader";
import { useUser } from "../context/UserContext";

export default function RequireAuth() {
  const isAuth = useIsAuthenticated();
  const { inProgress } = useMsal();
  const { user, loading } = useUser();
  const location = useLocation();

  if (inProgress === "startup" || inProgress === "handleRedirect") {
    return <Loader text="Verificando sessão..." />;
  }

  if (!isAuth) {
    const url = location.pathname + location.search;
    return <Navigate to={`/?redirect=${encodeURIComponent(url)}`} replace />;
  }

  // Keep the error page available when the API is unavailable and the user
  // profile therefore cannot be loaded.
  if (location.pathname === "/error") return <Outlet />;

  if (loading) return <Loader text="A carregar..." />;

  if (!user) return <Navigate to="/not-registered" replace />;

  return <Outlet />;
}
